import { Url, IUrl, Singleton } from "app/utils";
import {
  Application,
  $Constants,
  $CurrentUser,
  $Router,
  $Analytics,
} from "app/classes";
import { $IdentityResource } from "app/resources";
import {
  IdentityService,
  $RavenService,
  intercomService,
  googleAnalyticsService,
  $LaunchDarklyService,
} from "app/services";
import { angular, app } from "app/ng/ng.module";
export class CommercePlatform {
  public ngLoaded = false;

  public init(): void {

     
      $Analytics.registerServices([
          intercomService,
          googleAnalyticsService
      ]);
      $Analytics.initServices();

      $IdentityResource.setEnvironment($Constants.env);

      this.registerPublicApps();
      // Passing in the hardcoded launchpad app
      // that we want to use at the top of the app
      // switcher.
      $CurrentUser
        .startSession($Constants.hardcodedLaunchpad)
        .catch(() => {}) // noop for no session
        .finally($Router.gotoSavedRoute);

      $CurrentUser.onLogin(() => {
        this.loadAngularApp();
        $RavenService.setupUser($CurrentUser);
        $CurrentUser.apps.forEach($Router.registerApp);
        $Analytics.setUser($CurrentUser);
        $Router.broadcast("userAuthenticated", { token: $CurrentUser.token });
      });

      $CurrentUser.onLogout(() => {
        $Router.broadcast("userUnauthenticated");
        $Router.unregisterApps();
        $LaunchDarklyService.logoutUser();
        // If the user does not have the correct org token, we want to retain
        // her savedRoute so that we can send her to it once she has the
        // correct org token.
        if ($CurrentUser.hasCorrectOrgToken()) {
          $Router.saveRoute();
        }

        // Determines if the url contains an org_id query param
        const currentUrl = Url.getCurrent();
        const currentUrlObj = Url.parse(currentUrl);
        const searchObj = Url.parseSearch(currentUrlObj.search);
        const orgId = searchObj["cp.orgid"];
        const orgId_queryParam = orgId ? `&cp.orgid=${orgId}` : "";
        $Router.goto(`auth/login?${orgId_queryParam}`);
      });
  }

  /**
   * Load the Angular portion of our application. This is deferred until the
   * user is logged in to save on load times.
   */
  public loadAngularApp(): void {
    if (!this.ngLoaded) {
      const bluebar = document.getElementById("bluebar");
      angular.bootstrap(bluebar, [app]);
      this.ngLoaded = true;
    }
  }

  private registerPublicApps() {
    const apps = $Constants.apps || [];
    apps.forEach((appDefinition) => {
      $Router.registerApp(new Application(appDefinition));
    });
  }
}

export let $CommercePlatform = Singleton("$CommercePlatform", CommercePlatform);
